import { createSelector } from "reselect";
import getLocationMetadata from "../base_getters/get_location_metadata";

const getPageNotFound = createSelector([
  getLocationMetadata
], (locationMetadata) => locationMetadata.pageNotFound || false);

export default getPageNotFound;